import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, PlayCircle, Search } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-48 pb-20 overflow-hidden bg-slate-50" data-id="element-263">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0 flex justify-end" data-id="element-264">
        <div className="w-full lg:w-[100%] h-full relative" data-id="element-265">
          <img src="https://www.thedailystar.net/sites/default/files/2026-01/MD.Tamim%20Ahmed%20ID2023-2-66-028%202.jpg" alt="EWU Campus" className="w-full h-full object-cover opacity-50" data-id="element-266" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-50 via-slate-50/80 to-transparent" data-id="element-267" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full" data-id="element-268">
        <div className="max-w-4xl" data-id="element-269">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-270">
            <div className="inline-flex items-center space-x-2 bg-gold/10 border border-gold/20 rounded-full px-4 py-1.5 mb-8" data-id="element-271">
              <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-272" />
              <span className="text-xs font-semibold tracking-wider uppercase text-gold" data-id="element-273">
                Admissions Open for Summer 2026
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-[1.1] mb-6 text-navy" data-id="element-274">
              Shape Tomorrow's <br data-id="element-275" />
              <span className="text-gold" data-id="element-276">Innovation Today</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 max-w-2xl leading-relaxed mb-12" data-id="element-277">
              Ranked among the top universities in Bangladesh, empowering global
              minds with a North American-style curriculum and world-class
              research facilities.
            </p>
          </motion.div>

          {/* Program Finder */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-white border border-slate-200 p-3 rounded-2xl max-w-3xl mb-12 flex flex-col md:flex-row items-center gap-3 shadow-lg" data-id="element-278">
            <div className="relative w-full md:w-1/3" data-id="element-279">
              <select className="w-full appearance-none bg-white border border-slate-300 rounded-xl py-3 pl-4 pr-10 text-sm focus:outline-none focus:border-navy text-slate-800 transition-colors cursor-pointer" data-id="element-280">
                <option value="undergrad" data-id="element-281">Undergraduate</option>
                <option value="grad" data-id="element-282">Graduate</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-283" />
            </div>

            <div className="relative w-full md:w-1/2" data-id="element-284">
              <select className="w-full appearance-none bg-white border border-slate-300 rounded-xl py-3 pl-4 pr-10 text-sm focus:outline-none focus:border-navy text-slate-800 transition-colors cursor-pointer" data-id="element-285">
                <option value="" disabled selected className="text-slate-400" data-id="element-286">
                  Select Department...
                </option>
                <option value="cse" data-id="element-287">Computer Science & Engineering</option>
                <option value="bba" data-id="element-288">Business Administration</option>
                <option value="pharmacy" data-id="element-289">Pharmacy</option>
                <option value="law" data-id="element-290">Law</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-291" />
            </div>

            <button className="w-full md:w-auto bg-gold hover:bg-gold-hover text-white font-bold py-3 px-6 rounded-xl transition-all shadow-md flex items-center justify-center whitespace-nowrap" data-id="element-292">
              <Search className="w-4 h-4 mr-2" data-id="element-293" />
              Find Program
            </button>
          </motion.div>

          {/* Dual CTAs */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-294">
            <button className="w-full sm:w-auto bg-navy text-white font-bold py-3.5 px-8 rounded-xl hover:bg-navy/90 transition-colors shadow-md" data-id="element-295">
              Explore Summer 2026 Admissions
            </button>
            <button className="w-full sm:w-auto border-2 border-navy text-navy hover:bg-navy hover:text-white font-semibold py-3.5 px-8 rounded-xl transition-colors flex items-center justify-center" data-id="element-296">
              <PlayCircle className="w-5 h-5 mr-2" data-id="element-297" />
              Take a Virtual Campus Tour
            </button>
          </motion.div>
        </div>
      </div>

      {/* Autoplay indicator for carousel feel */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2 z-10" data-id="element-298">
        <div className="w-8 h-1.5 bg-navy/80 rounded-full" data-id="element-299" />
        <div className="w-2 h-1.5 bg-slate-300 rounded-full" data-id="element-300" />
        <div className="w-2 h-1.5 bg-slate-300 rounded-full" data-id="element-301" />
      </div>
    </section>;
}